import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const galleryItems = [{
  id: 1,
  location: 'Scottsdale, AZ',
  image: 'https://cdn.magicpatterns.com/uploads/gAQ8CH4R4tkxrQSMebSHV6/Frame-1948755014-1.png'
}, {
  id: 2,
  location: 'Mesa, AZ',
  image: 'https://cdn.magicpatterns.com/uploads/uTGq9bGcUxa8c6f9F1oFqj/image7.png'
}, {
  id: 3,
  location: 'Gilbert, AZ',
  image: 'https://cdn.magicpatterns.com/uploads/dtLRbtJaDmNnuVpMUWKXZo/image13.png'
}, {
  id: 4,
  location: 'Chandler, AZ',
  image: 'https://cdn.magicpatterns.com/uploads/eCJoHgzE3dDjdoMVXyt8YA/image14.png'
}, {
  id: 5,
  location: 'Phoenix, AZ',
  image: 'https://cdn.magicpatterns.com/uploads/13TFKd9HF6YU2a8nDLGXMe/images15.png'
}];
export function GallerySection() {
  return <section id="gallery" className="py-12 md:py-24 px-4 md:px-6 bg-white overflow-hidden" data-id="element-96">
      <div className="container mx-auto max-w-7xl" data-id="element-97">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-12 gap-4" data-id="element-98">
          <div data-id="element-99">
            <span className="text-brand-red uppercase text-sm font-bold tracking-wider block mb-2 md:mb-3" data-id="element-100">
              Our Work
            </span>
            <h2 className="text-charcoal text-2xl md:text-4xl font-bold uppercase tracking-wide" data-id="element-101">
              See the Redline Difference
            </h2>
          </div>
          <a href="#gallery" className="inline-flex items-center text-brand-red font-bold hover:text-brand-red-dark transition-colors group text-sm md:text-base min-h-[44px]" data-id="element-102">
            View Full Gallery
            <ArrowRightIcon className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-103" />
          </a>
        </div>

        {/* Horizontal Scrolling Container */}
        <div className="flex overflow-x-auto snap-x snap-mandatory gap-4 md:gap-6 pb-4 md:pb-8 -mx-4 px-4 md:mx-0 md:px-0 hide-scrollbar" data-id="element-104">
          {galleryItems.map(item => <div key={item.id} className="min-w-[80vw] sm:min-w-[75vw] md:min-w-[500px] lg:min-w-[600px] snap-center flex-shrink-0 bg-white rounded-lg md:rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-105">
              <div className="relative w-full overflow-hidden max-h-[250px] md:max-h-none" data-id="element-106">
                <img src={item.image} alt={`Before and after pool cleaning in ${item.location}`} className="w-full h-auto object-cover" data-id="element-107" />
              </div>

              <div className="p-3 md:p-5 bg-white" data-id="element-108">
                <p className="font-bold text-charcoal text-base md:text-lg flex items-center gap-2" data-id="element-109">
                  <span className="w-2 h-2 rounded-full bg-brand-red flex-shrink-0" data-id="element-110"></span>
                  {item.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}